import courseService from '@/services/StatementService.js'

export const namespaced = true

export const state = {
  courses: [],
  coursesTotal: 0,
  course: {},
  perPage: 12,
  totalPages: 0,
  agent: {}
}

export const mutations = {
  ADD_COURSE(state, course) {
    state.courses.push(course)
  },
  SET_COURSES(state, courses) {
    state.courses = courses
  },
  SET_COURSES_TOTAL(state, coursesTotal) {
    state.coursesTotal = coursesTotal
  },
  SET_COURSE(state, course) {
    state.course = course
  },
  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages
  },
  SET_AGENT(state, data) {
    state.agent.id = data.id
    state.agent.name = data.name
  },
  SET_AGENT_COURSES(state, courses) {
    state.agent.courses = courses
  }
}

export const actions = {
  fetchCourses({ commit, dispatch, state }, { page, sort }) {
    return courseService
      .getCourses(state.perPage, page, sort)
      .then(response => {
        commit('SET_COURSES_TOTAL', parseInt(response.data.totalElements))
        commit('SET_TOTAL_PAGES', parseInt(response.data.totalPages))
        commit('SET_COURSES', response.data.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching statements: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  search({ commit, getters, state }, name) {
    return courseService.search(name).then(response => {
      return response.data
    })
  },
  serverFetchCourse({ commit, getters, state }, id) {
    return courseService.getCourse(id).then(response => {
      commit('SET_COURSE', response.data)
      return response.data
    })
  },
  fetchCourse({ commit, getters, state }, id) {
    if (id == state.course.id) {
      return state.course
    }

    return courseService.getCourse(id).then(response => {
      commit('SET_COURSE', response.data)
      return response.data
    })
  },
  fetchAgentCourse({ commit, getters, state }, { id, name }) {
    if (
      id == state.agent.id &&
      state.agent.courses != null &&
      state.agent.courses !== undefined
    ) {
      return Object.assign([], state.agent.courses)
    }

    return courseService.getAllAgentCourses(id).then(response => {
      if (
        name === '' ||
        (name === undefined &&
          response.data[0] != null &&
          response.data[0] !== undefined &&
          response.data[0].interactions != null &&
          response.data[0].interactions !== undefined)
      ) {
        name = response.data[0].interactions[0].name
      }
      commit('SET_AGENT', { id: id, name: name })
      commit('SET_AGENT_COURSES', response.data)
      return response.data
    })
  }
}

export const getters = {
  getCourseById: state => id => {
    return state.courses.find(course => course.id === id)
  },
  getAgentById: state => id => {
    if (id == state.agent.id) {
      return state.agent
    }
  },
  hasCourses: state => {
    return state.courses.length > 0
  }
}
